import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import style from './AsideMenu.module.scss';

import AppRouter from 'stores/AppRouter';
import { ROUTES } from 'routes/routes';
import ModalStore from 'stores/ModalStore';

import Button from 'components/Button/Button';
import EmailNewModal from 'components/Modals/EmailNew/EmailNewModal';

@observer
class HostessControls extends Component {
  render() {
    return (
      <div className={style.controls}>
        <Button className={style.btn} onClick={this._handleSendEmailClick}>
          <FormattedMessage
            id="button.email.send"
            defaultMessage="Send E-Mail"
          />
        </Button>

        <Button className={style.btn} onClick={this._handleEmailOverviewClick}>
          <FormattedMessage
            id="button.email.list"
            defaultMessage="E-Mail overview"
          />
        </Button>
      </div>
    );
  }

  private _handleSendEmailClick = async () => {
    await ModalStore.showModal(EmailNewModal);
  };

  private _handleEmailOverviewClick = () => {
    AppRouter.push(ROUTES.emails);
  };
}

export default HostessControls;
